function tabForm(){
    this.eventButtons = {};
    this.eventButtons.proceed = 'tabFormProceed';
    this.eventButtons.back = 'tabFormBack';
    
    this.innerText = {};
    this.innerText.proceed = 'Proceed';
    this.innerText.submit = 'Submit';
    this.innerText.back = 'Back';
    
    this.selectors = {};
    this.selectors.hideClassName = 'hide';

}

tabForm.prototype.autoForward = function(leftTabs, withField){
   
    var tabPassCount = 0;
    var thisNode , thisNodeFields, im, thisnodeWith , tagField, nodeEmptyFieldsCount, nodePackageTypeWith, fieldValue, innerFieldsCount;
    var requiredIndexes = {};
    var tabsCount = leftTabs.tabsCount;
    var topWithCheck;
    var innerAttr, validationField;
    var formIdName = leftTabs.formIdName, form = $('#'+formIdName), mainWrappersClassName = leftTabs.mainWrappersClassName, mainWrappers = $('.'+mainWrappersClassName);
    var feed =  (leftTabs.feedBoxIdName!=undefined) ? $('#'+leftTabs.feedBoxIdName) : false;
    
    if(leftTabs.feedBoxIdName!=undefined){
        //feed.addClass('hide').css('color','#000000').text('').hide();
    }

       for(var ij in leftTabs.fields){

        thisNode = leftTabs.fields[ij];
        
        thisnodeWith = (thisNode.with != undefined) ? thisNode.with : false;
        nodeEmptyFieldsCount = 0;
        topWithCheck = (thisnodeWith != false) ? (thisnodeWith.indexOf(withField) >= 0) : false;

        if (topWithCheck) {
            thisNodeFields = thisNode.fields;
            innerFieldsCount = 0;

            for (im in thisNodeFields) {
                
                
                nodePackageTypeWith = thisNodeFields[im].with;
                if (nodePackageTypeWith.indexOf(withField) >= 0) {
                    switch (thisNodeFields[im].handType) {
                        case 'name' :
                            tagField = $('[name=' + thisNodeFields[im].hand + ']');
                            break
                        case 'id' :
                            tagField = $('#' + thisNodeFields[im].hand);
                            break
                        case 'class' :
                            tagField = $('.' + thisNodeFields[im].hand);
                            break
                    }
                    if (thisNodeFields[im].multi) {
                        validationField = thisNodeFields[im].validation;
                        var requiredOneCheckedCount;
                        if(validationField!=undefined && validationField.indexOf('required:one:checked')>=0){
                             var requiredOneCheckedCount = 0;
                        }
                       
                         
                        $.each(tagField, function (uoi, oud) {
                            fieldValue = $(this).val();
                            
                            console.log(tagField.attr('name')+'**'+fieldValue);
                            if (tagField.hasClass('required')) {
                                if (fieldValue == '') {
                                    innerFieldsCount++;
                                }
                            }
                            if (tagField.hasClass('number')) {
                                if ((isNaN(fieldValue))) {
                                    innerFieldsCount++;
                                }
                            }
                            if (tagField.hasClass('custEmail')) {
                                if (/^[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/.test(fieldValue) == false) {
                                    innerFieldsCount++;
                                }
                            }
                            innerAttr = tagField.attr('minlength');
                            if (typeof innerAttr !== typeof undefined && innerAttr !== false && fieldValue.length < parseInt(innerAttr)) {
                                innerFieldsCount++;
                            }

                            innerAttr = tagField.attr('maxlength');
                            if (typeof innerAttr !== typeof undefined && innerAttr !== false && fieldValue.length > parseInt(innerAttr)) {
                                innerFieldsCount++;
                            }
                            
                            
                            if(validationField!=undefined && validationField.indexOf('required:one:checked')>=0){
                                if($(this).is(":checked")){
                                   requiredOneCheckedCount++; 
                                }
                            }
                            
                        });
                        
                        if(requiredOneCheckedCount!=undefined && requiredOneCheckedCount==0){
                            innerFieldsCount++;
                            if(leftTabs.feedBoxIdName!=undefined){
                                //feed.removeClass('hide').css('color','red').text('Check atleast one input:check box '+tagField.eq(0).attr('name')).show();
                            }
                            break;
                        }
                    } else {
                        fieldValue = tagField.val();
                        console.log(tagField.attr('name')+'**'+fieldValue);
                        if (tagField.hasClass('required')) {
                            if (fieldValue == '') {
                                innerFieldsCount++;
                            }
                        }
                        if (tagField.hasClass('number')) {
                            if ((isNaN(fieldValue))) {
                                innerFieldsCount++;
                            }
                        }
                        if (tagField.hasClass('custEmail')) {
                            if (/^[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/.test(fieldValue) == false) {
                                innerFieldsCount++;
                            }
                        }
                        innerAttr = tagField.attr('minlength');
                        if (typeof innerAttr !== typeof undefined && innerAttr !== false && fieldValue.length < parseInt(innerAttr)) {
                            innerFieldsCount++;
                        }
                        
                        innerAttr = tagField.attr('maxlength');
                        if (typeof innerAttr !== typeof undefined && innerAttr !== false && fieldValue.length > parseInt(innerAttr)) {
                            innerFieldsCount++;
                        }
                        
                        validationField = thisNodeFields[im].validation;
                        if(validationField!=undefined && validationField.indexOf('required')>=0){
                            if(fieldValue==undefined){
                                innerFieldsCount++;
                            } else if(fieldValue==''){
                                 innerFieldsCount++;
                            }
                        }

                    }

                }
            }

            if (innerFieldsCount == 0) {
                tabPassCount++;
            }

            requiredIndexes[thisNode.leftLink] = parseInt(innerFieldsCount);
        } else {
            tabPassCount++;
        }

    }
        var reLeng = Object.keys(requiredIndexes).length;
        var addEditButton = $('#'+leftTabs.buttons.addEditButton);
        
        console.log('required indexes ----------');
        console.log(requiredIndexes);
        
        
        var leftTabWrapperIdName = leftTabs.leftTabMainwrappers;
        var targetLeftNav;
        var zX = 0;
        var fX = 0;
        
        console.log('relen is '+reLeng);
        
        $.each(requiredIndexes,function(ki,kd){
            if(zX < (parseInt(reLeng) - 1)){
                if(parseInt(kd)==0){
                    fX++;
                }
            }
            zX++;
        });
        
        console.log('fx is '+fX);
        
        if(fX==(parseInt(reLeng) - 1)){
            console.log('check 1 ');
            var tg = parseInt($('#'+leftTabWrapperIdName).find('li.active').find('a').attr('data-tabindex'));
                
                
                if(hasBothClass($('#'+leftTabWrapperIdName).find('li').eq((tg)), ['li-tab-sat','hide'])){ // if in case the next index is hidden then skip to the next visible tab
                    tg++;
                }
                targetLeftNav =  $('#'+leftTabWrapperIdName).find('li').eq((tg)).find('a').attr('id');
        } else {
            $.each(requiredIndexes,function(mzi,mzd){
                if(parseInt(mzd)>0){
                    targetLeftNav = mzi;
                    return false; 
                }
            });
            console.log('check 2');
        }
        
        console.log('targetLeftNav is '+targetLeftNav);
        
        var beforeClickIndex = parseInt($('#'+leftTabWrapperIdName).find('li.active').find('a').attr('data-tabindex'));
         
        if(targetLeftNav!=undefined){
            var target = $('#'+targetLeftNav);
            var selectedTabIndex = parseInt(target.attr('data-tabindex'));
            var backButton = $('#'+leftTabs.buttons.backButton);    
            var targetDiv = $('#'+target.attr('data-target'));
            var wrapperActiveClassArray = (leftTabs.wrapperActiveClass== undefined) ? ['active', 'fade' ,'in'] : leftTabs.wrapperActiveClass;
           
           
        console.log('tab pass count is '+tabPassCount);
        console.log('tab index is '+selectedTabIndex);
        console.log('rl length is'+reLeng);
         
         
            if(tabPassCount>=(reLeng - 1) && selectedTabIndex == parseInt(leftTabs.tabsCount)){
                addEditButton.text('Submit').addClass(addEditButton.data('submit-class'));
            } else {
                addEditButton.text('Proceed');
            }

                $.each(target.find('li').find('a'),function(){
                    $(this).attr('aria-expanded','false');
                });
                
                $('#'+leftTabWrapperIdName).find('li.active').removeClass('active');
                target.attr('aria-expanded','true');
                target.parent('li').addClass('active');
                
                $.each(form.find('.'+mainWrappersClassName),function(){
                    removeAllClass($(this), wrapperActiveClassArray);
                });
                addAllClass(targetDiv, wrapperActiveClassArray);
                
                // targetDiv.addClass('active');
                if(selectedTabIndex>1){
                    backButton.removeClass('hide');
                } else {
                    backButton.addClass('hide');
                }
              
                this.removeDisabledClassTargetAndResetAll(leftTabs,target.parent('li'));
                

        }
        
        var returnStatus = false;
        
        
        console.log('-----tab index is '+selectedTabIndex);
        console.log('-----total tabs '+leftTabs.tabsCount);
        console.log('-----final re length is '+reLeng);
        
        var ciDx = parseInt($('#'+leftTabWrapperIdName).find('li.active').find('a').attr('data-tabindex'));
        
        console.log('-----ciDx is '+ciDx);
        
       console.log('before click index is - '+beforeClickIndex);
        
        if((tabPassCount) >= (parseInt(tabsCount)) &&  ciDx >= parseInt(tabsCount) && beforeClickIndex==(parseInt(tabsCount))){
            returnStatus = true;
        }
        
        var checkReturns = {'tabs' : requiredIndexes, 'status' : returnStatus};
        
        return checkReturns;
}

tabForm.prototype.removeDisabledClassTargetAndResetAll = function(leftTabs,target){
    
    var leftLists;
     
    if(leftTabs.leftTabMainwrappers!=undefined){
        leftLists = $('#'+leftTabs.leftTabMainwrappers+' li');
    } else if(leftTabs.tabUlIdName!=undefined){
       leftLists = $('#'+leftTabs.tabUlIdName+' li');
    }
    
    if(leftLists!=undefined){
        for(var fgi = 0; fgi< leftLists.length; fgi++){
            if(leftLists.eq(fgi).hasClass('disabled')==false)
            {
                leftLists.eq(fgi).addClass('disabled'); 
            }
        }
        target.removeClass('disabled');  
    }

};

tabForm.prototype.setToFirstTab = function(arg){
    
    var tabUlIdName = arg.tabUlIdName;
    var tabActiveClass = (arg.tabActiveClass!=undefined) ? arg.tabActiveClass : 'active';
    var wrapperActiveClass = (arg.wrapperActiveClass!=undefined) ? arg.wrapperActiveClass : 'fade in active';
    var formIdName = arg.formIdName, form = $('#'+formIdName);
    var tabLi = $('#'+tabUlIdName+' li');
    var wrappers = $('.'+arg.mainWrappersClassName);
    var tabForm = this;
    
    $.each(tabLi,function(i,d){
        $(this).removeClass(tabActiveClass);
    });
    
    $.each(form.find('.'+arg.mainWrappersClassName),function(i,d){
        $(this).removeClass(wrapperActiveClass);
    });
    
    tabLi.eq(0).addClass(tabActiveClass);
    form.find('.'+arg.mainWrappersClassName).eq(0).addClass(wrapperActiveClass);
    
    this.removeDisabledClassTargetAndResetAll(arg,$('#'+arg.tabUlIdName+' li').eq(0));
    
    form.find('.'+tabForm.eventButtons.proceed).text(tabForm.innerText.proceed).removeClass(tabForm.selectors.hideClassName);
    form.find('.'+tabForm.eventButtons.back).text(tabForm.innerText.back).addClass(tabForm.selectors.hideClassName);
};


tabForm.prototype.goBacK = function(leftTabs){
       var submitButton  = $('#'+leftTabs.buttons.addEditButton);
       var backButton = $('#'+leftTabs.buttons.backButton);
       var addPackageLeftTabWrapperIdName = leftTabs.leftTabMainwrappers;
       var currentIndex =  parseInt($('#'+addPackageLeftTabWrapperIdName).find('li.active').attr('data-tabindex'));
       var tabLists = $('#'+addPackageLeftTabWrapperIdName+' li');
       var mainWrappersClassName = leftTabs.mainWrappersClassName; 
       var mainWrappers = $('.'+mainWrappersClassName);
       var wrapperActiveClassArray = (leftTabs.wrapperActiveClass== undefined) ? ['active', 'fade' ,'in'] : leftTabs.wrapperActiveClass;
       var formIdName = leftTabs.formIdName, form = $('#'+formIdName);
       var participatingTabsCount = 0;
       var index;
            
            for(var i=0;i<tabLists.length;i++ ){
                var li = tabLists.eq(i);
                if(hasBothClass(li, ['li-tab-sat','hide'])){}else{
                     participatingTabsCount++;
                }
            }
            
            for(var i=0;i<tabLists.length;i++ ){
                var target = tabLists.eq(i);
                if(target.hasClass('active')){
                    index = i;
                    break;
                }
            }
            
            var targetIndex;
            if(index!=undefined){
                index == parseInt(index);
                
                if(index==(participatingTabsCount)){
                   submitButton.text('Submit'); 
                } else {
                    submitButton.text('Proceed'); 
                }
                
                if(index==(participatingTabsCount - 1)){
                   targetIndex = parseInt(parseInt(participatingTabsCount) - 2);
                } else {
                    targetIndex = parseInt(index - 1);
                }
                
                if(hasBothClass($('#'+addPackageLeftTabWrapperIdName+' li').eq(targetIndex), ['li-tab-sat','hide'])){
                    targetIndex = (parseInt(targetIndex) - 1);
                    targetIndex = (targetIndex<0) ? 0 : parseInt(targetIndex);
                }

            }
            
            $.each(tabLists,function(){
                $(this).removeClass('active');
                $(this).find('a').attr('aria-expanded','false');
            });
           
           if(parseInt(targetIndex)==0){
               backButton.addClass('hide');
           } else {
               backButton.removeClass('hide');
           }
           
           tabLists.eq(targetIndex).addClass('active');
           var wrapper = tabLists.eq(targetIndex).find('a').attr('data-target');
           $.each(form.find('.'+mainWrappersClassName),function(){
                removeAllClass($(this), wrapperActiveClassArray);
           });
           
           addAllClass($('#'+wrapper), wrapperActiveClassArray);
           
           this.removeDisabledClassTargetAndResetAll(leftTabs,tabLists.eq(targetIndex));
           
};

function hasBothClass(selector, classList){
    var hasClassCount = 0;
    var check = false;
    for(var i in classList){
       if(selector.hasClass(classList[i])){
           hasClassCount++;
       } 
    }
    if(hasClassCount==classList.length){
        check = true;
    }
    return check;
}


function addAllClass(selector, classList){
    for(var ki in classList){
       selector.addClass(classList[ki]);
    }
}

function removeAllClass(selector, classList){
    for(var kki in classList){
       selector.removeClass(classList[kki]);
    }
}


module.exports = new tabForm();